import React, {useState} from "react";
import { Box, Button, Grid } from "@mui/material";
import TextField from '@mui/material/TextField';
import { useMediaQuery, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { showLogin, showSignup, showPasswordRecovery, showWaiting } from '../../store/slices/configSlice';

import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// import * as yup from 'yup';
import {useYupSchema} from '../../components/util/hookYupSchema'
import { enqueueSnackbar } from 'notistack';

import {Footer} from '../../components/footer';
import { constants } from '../../util'
import { sendMessage } from "../../services/getInTouchService";






const GetInTouch = () => {
    const dispatch = useDispatch();
    const {deviceType} = useSelector(state => state.configuration);
    //TRANSLATION
    const [t, i18n] = useTranslation("global");
    
    const sch = (yup) => yup.object({
        name: yup.string().required().min(3).max(40),  
        email: yup.string().email().required().min(6).max(40),
        message: yup.string().required().min(10).max(200),
    });
    const schema = useYupSchema(sch);

    const theme = useTheme();
    const isSm = useMediaQuery(theme.breakpoints.down('sm'));
    const isMd = useMediaQuery(theme.breakpoints.down('md'));
    const isXl = useMediaQuery(theme.breakpoints.down('xl'));

    let screenSize = 4;
    if (isSm) screenSize = 1;
    else if (isMd) screenSize = 2;
    else if (isXl) screenSize = 3;


    const { register, handleSubmit, reset, formState: { errors } } = useForm({
            resolver: yupResolver(schema),
        });
        
    const onSubmit = (data) => {
        dispatch(showWaiting(true));
        sendMessage(data.name, data.email, data.message)
            .then(rsp => {
                if (rsp.code==='00'){
                    setTimeout(() => {
                        enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                        dispatch(showWaiting(false));
                        reset();
                    }, 1500);
                }
                else{
                    setTimeout(() => {
                        enqueueSnackbar(rsp.message, { variant: 'success', persist: false });
                        dispatch(showWaiting(false));
                    }, 1000);
                }
            })
    }


    return(
        <>
            <div style={{
                marginTop: '250px',
                padding: 0,
                border: 0,
                left:0,
                // top:350,
                width: '100%',
                height: '100%',
                display: deviceType==='minicell' || deviceType==='cell' ? 'none' : 'block',
                position: 'absolute',
                backgroundImage: "url('/assets/img/generic/litop.png')",
                backgroundSize: '100px 350px',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left',
                zIndex: 0, 
            }}></div>
            <Box sx={{
                top: 0,
                margin: 0,
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                minHeight: '100vh', // asegura que ocupe toda la altura de la ventana
                width: '100%',
                backgroundColor: '#313233',
                backgroundImage: "url('/assets/img/generic/fondo-black.svg')",
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
            }}>
                <Box sx={{ flex: 1, }}>
                    <div style={{
                            margin: 0,
                            padding: 0,
                            border: 0,
                            width: '100%',
                            height: '110px',
                            marginTop: '80px',
                            display: 'block',
                            position: 'absolute',
                            backgroundImage: "url('/assets/img/generic/Roto2.svg')",
                            backgroundSize: 'cover',
                            backgroundRepeat: 'no-repeat',
                            backgroundPosition: 'left',
                            zIndex: 10,
                        }}></div>
                    <Grid container direction='row' sx={{marginTop:'200px'}}>
                        <Grid size={screenSize===1 ? 12 : (screenSize===2 ? 4 : 5)} sx={{textAlign:screenSize===1 ? 'center' : 'left', marginBottom:'20px'}}>
                            <h1 
                                className={screenSize<=2 ? 'text-subtitle animate pop delay-2' : 'text-title animate pop delay-2'} 
                                style={{color:'white', marginLeft:screenSize===1 ? '0px' : '60px'}}
                            >
                                {t("getInTouch.title")}
                            </h1>
                        </Grid>
                        <Grid size={screenSize===1 ? 12 : (screenSize===2 ? 8 : 7)}>
                            <Box className='animate pop delay-4' sx={{
                                width:'80%',
                                padding:'40px',
                                justifySelf:'center',
                                backgroundColor:'#f3f3f3',
                                border:'1px solid black',
                                borderRadius:'15px',
                                boxShadow:'3px 3px 3px 3px',
                                marginBottom:'200px'
                            }}>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <TextField id="txtNombre" label={t("getInTouch.txtName")} variant="outlined" margin="dense" autoFocus fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}} 
                                        {...register('name')}
                                        error={!!errors.name}
                                        helperText={errors.name?.message} />
                                    <TextField id="txtCorreo" label={t("getInTouch.txtEmail")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}} 
                                        {...register('email')}
                                        error={!!errors.email}
                                        helperText={errors.email?.message} />
                                    <TextField id="txtMensaje" multiline rows={3} label={t("getInTouch.txtMessage")} variant="outlined" margin="dense" fullWidth sx={{...constants.styles.textfield, backgroundColor:'white', border:'1px solid #e1e1e1', marginBottom:'15px'}} 
                                        {...register('message')}
                                        error={!!errors.message}
                                        helperText={errors.message?.message} />
                                    <Button variant="text" sx={{ ...constants.styles.mainButton }} type="submit">{t("getInTouch.txtSubmit")}</Button>
                                </form>
                            </Box> 
                        </Grid>
                    </Grid>
                </Box>
                <Footer />
            </Box>
        </>
    );
}

export default GetInTouch;